export default __webpack_public_path__ + "static/media/LoginBackgroundImage.ad4e7d99.jpg";